import { render, staticRenderFns } from "./Mlabel.vue?vue&type=template&id=246d8ab3&scoped=true&"
import script from "./Mlabel.vue?vue&type=script&lang=js&"
export * from "./Mlabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246d8ab3",
  null
  
)

export default component.exports